'use es6';

import getComponentName from 'react-utils/getComponentName';
import { path } from 'rich-text-lib/utils/iterables';
import { jsx as _jsx } from "react/jsx-runtime";
const withFindReplace = WrappedComponent => {
  function FindReplace(props) {
    const {
      editor
    } = props;
    const renderPopover = path(['toolbarPopovers', 'hsfindreplace', 'renderPopover'], editor);
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
      renderFindReplace: renderPopover
    }, props));
  }
  FindReplace.displayName = `WithFindReplace(${getComponentName(WrappedComponent)})`;
  return FindReplace;
};
export default withFindReplace;